<div class="card">
  <app-header
    titulo="Painel de Custos"
    descricao="Painel de integração de custos"
  ></app-header>

  <p-tabView>
    <p-tabPanel header="Dados">
      <p-multiSelect
        appendTo="body"
        [options]="instancias"
        [filter]="true"
        [style]="{ width: '200px' }"
        optionValue="id"
        optionLabel="nome"
        [(ngModel)]="instanciaSelecionada"
        dataKey="id"
        inputId="id"
        placeholder="Instância"
        emptyMessage="Nenhuma instância"
        (onPanelHide)="onInstanciaChange($event)"
      >
      </p-multiSelect>
      <p-calendar
        class="ml-3"
        [(ngModel)]="rangeDates"
        selectionMode="range"
        dateFormat="dd/mm/yy"
        [readonlyInput]="true"
        (onClose)="onDateChange($event)"
      />

      <!--p-multiSelect
        class="ml-3"
        appendTo="body"
        [options]="processos"
        [filter]="true"
        [style]="{ width: '200px' }"
        optionValue="id"
        optionLabel="nome"
        [(ngModel)]="processosSelecionados"
        dataKey="id"
        inputId="id"
        placeholder="Processos"
        emptyMessage="Nenhum processo"
        selectedItemsLabel="Vários selecionados"
      >
      </p-multiSelect>
      <button
        class="ml-3"
        pButton
        pRipple
        icon="pi pi-refresh"
        label="Buscar ERP"
        [loading]="loadingSincronizar"
        [disabled]="loading"
      ></button-->

      <div class="mt-4">
        <p-tabView>
          <p-tabPanel header="Despesas Gerais">
            <app-custodespesageral />
          </p-tabPanel>
          <p-tabPanel header="Consumo">
            <app-custoconsumo />
          </p-tabPanel>
          <p-tabPanel header="Depreciação">
            <app-custodepreciacao />
          </p-tabPanel>
          <p-tabPanel header="Horas Manutenção">
            <app-custohoramanutencao />
          </p-tabPanel>
        </p-tabView>
      </div>
    </p-tabPanel>

    <!-- ABA PROCESSAR-->
    <p-tabPanel header="Processar">
      <div >
        <p-dropdown
        appendTo="body"
        [options]="instancias"
        [filter]="true"
        [style]="{ width: '200px' }"
        optionValue="id"
        optionLabel="nome"
        [(ngModel)]="instanciaSelecionada"
        dataKey="id"
        inputId="id"
        placeholder="Instância"
        emptyMessage="Nenhuma instância"
        (onChange)="carregaPeriodos($event)"
      >
      </p-dropdown>
      <p-dropdown
      class="ml-3"
        appendTo="body"
        [options]="periodosLiberados"
        [filter]="true"
        [style]="{ width: '300px' }"
        
        optionLabel="nome"
        [(ngModel)]="periodoSelecionado"
        
        placeholder="Períodos"
        emptyMessage="Nenhum Período"
        
      >
      <ng-template pTemplate="selectedItem">
        <div class="flex align-items-center gap-2" *ngIf="periodoSelecionado">
          <div>Período de {{ periodoSelecionado.dataInicio | date: 'dd/MM/yyyy' }} à {{ periodoSelecionado.dataFim | date: 'dd/MM/yyyy' }}</div>
        </div>
    </ng-template>
      <ng-template let-periodo pTemplate="item">
        <div class="flex align-items-center gap-2">
            <div>Período de {{ periodo.dataInicio | date: 'dd/MM/yyyy' }} à {{ periodo.dataFim | date: 'dd/MM/yyyy' }}</div>
        </div>
    </ng-template>
      </p-dropdown>

      <p-multiSelect
        class="ml-3"
        appendTo="body"
        [options]="processos"
        [filter]="true"
        [style]="{ width: '200px' }"
        optionValue="id"
        optionLabel="nome"
        [(ngModel)]="processosSelecionados"
        dataKey="id"
        inputId="id"
        placeholder="Processos"
        emptyMessage="Nenhum processo"
        selectedItemsLabel="Vários selecionados"
      >
      </p-multiSelect>
      <p-button
        class="ml-3"
        
        pRipple
        icon="pi pi-refresh"
        label="Integrar ERP -> PIMS"
        [loading]="loadingSincronizar"
        [disabled]="loading"
        (onClick)="requisitaIntegracao()"
      ></p-button>
      </div>

      <div class="mt-3">
        <p-table [value]="processamentos" [lazy]="true" (onLazyLoad)="carregaProcessamento($event)" [paginator]="true" [rows]="100" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [rowsPerPageOptions]="[20, 50, 100]" [totalRecords]="totalRecords" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"  [scrollable]="true" scrollHeight="40.5rem" [resizableColumns]="true" [tableStyle]="{'font-size':'.9rem', 'font-weight':'400', 'border-spacing':'0 0 !important', 'border-colapse': 'separate'}"  #dt>
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="processo">Processo <p-sortIcon field="processo"></p-sortIcon></th>
              <th pSortableColumn="instancia">Instância <p-sortIcon field="instancia"></p-sortIcon></th>
              <th pSortableColumn="dtSolicitacao">Dt Solicitação <p-sortIcon field="dtSolicitacao"></p-sortIcon></th>
              <th pSortableColumn="dtInicio">Inicio <p-sortIcon field="dtInicio"></p-sortIcon></th>
              <th pSortableColumn="dtFim">Fim <p-sortIcon field="dtFim"></p-sortIcon></th>
              <th pSortableColumn="usuario">Usuário <p-sortIcon field="usuario"></p-sortIcon></th>
              <th pSortableColumn="fgStatusInteg">Status <p-sortIcon field="fgStatusInteg"></p-sortIcon></th>
              <th pSortableColumn="deMensagemInteg">Mensagem <p-sortIcon field="deMensagemInteg"></p-sortIcon></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-processamento>
            <tr>
              <td>{{ processamento.processo }}</td>
              <td>{{ processamento.instancia }}</td>
              <td>{{ processamento.dtSolicitacao | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>{{ processamento.dtInicio | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>{{ processamento.dtFim | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>{{ processamento.usuario }}</td>
              <td>{{ processamento.fgStatusInteg }}</td>
              <td>{{ processamento.deMensagemInteg }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <td colspan="21">Nenhum registro encontrado</td>
        </ng-template>
        </p-table>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Retorno">
      <app-custoretorno></app-custoretorno>
    </p-tabPanel>
  </p-tabView>
</div>
